export const DOCX_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const XLSX_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const CONTENT_TYPES : {
    [key: string]: string
} = {
    docx: DOCX_CONTENT_TYPE,
    xlsx: XLSX_CONTENT_TYPE
}